import { Admin                     ,
         Authentication            ,
         initializedAuthentication } from '../../dataTypes/adminManagment/types'

export enum ActionType
 {
  INIT_AUTHENTICATION = 'INIT_AUTHENTICATION' ,
  SET_LOGIN           = 'SET_LOGIN'           ,
  SET_TOKEN           = 'SET_TOKEN'           ,
  SET_ADMIN           = 'SET_ADMIN'           ,
  COUNT_ATTEMPT       = 'COUNT_ATTEMPT'
 }

export interface AuthenticationState
 {
  authentication: Authentication;
 }

export const initialState : AuthenticationState=
 {
  authentication: initializedAuthentication()
 }

export interface actionInitAuthentication
 {
  type:      ActionType.INIT_AUTHENTICATION;
  complete:  boolean;
 }

export interface actionSetLogin
 {
  type:  ActionType.SET_LOGIN;
  login: string;
 }

export interface actionSetToken
 {
  type:  ActionType.SET_TOKEN;
  token: string;
 }

export interface actionSetAdmin
 {
  type:  ActionType.SET_ADMIN;
  admin: Admin;
 }

export interface actionCountAttempt
 {
  type:  ActionType.COUNT_ATTEMPT;
 }

export type Action = actionInitAuthentication |
                     actionSetLogin           | 
                     actionSetToken           |
                     actionSetAdmin           |
					 actionCountAttempt       ;

export type DispatchTypeInitAuthentication = ( args: actionInitAuthentication ) => actionInitAuthentication
export type DispatchTypeSetLogin           = ( args: actionSetLogin           ) => actionSetLogin
export type DispatchTypeSetToken           = ( args: actionSetToken           ) => actionSetToken
export type DispatchTypeSetAdmin           = ( args: actionSetAdmin           ) => actionSetAdmin
export type DispatchTypeCountAttempt       = ( args: actionCountAttempt       ) => actionCountAttempt

					 
